"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transaction = void 0;
const currency_enum_1 = require("../common/currency.enum");
class Transaction {
    constructor(data) {
        if (data) {
            this.deserialize(data);
        }
    }
    deserialize(input) {
        Object.assign(this, input);
        this.id = input.id || input._id;
        if (!this.transactionData.currency)
            this.transactionData.currency = currency_enum_1.CurrencyEnum.EUR;
        return this;
    }
}
exports.Transaction = Transaction;
